module.exports = __webpack_public_path__ + "static/media/NexaBold.ae7533d8.woff2";